<template>
  <div>
    <div class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div class="col-6">
            <h4>High Low 5</h4>
          </div>
          <div class="col-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/' }"><feather type="home"></feather></router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/stock/scan' }">Scan</router-link>
              </li>
              <li class="breadcrumb-item active">High Low 5</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="board='main'">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>MAIN</span>
                          <h3 class="total-num counter">{{ stocks.filter(s => s.board==='main').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ stocks.filter(s => s.board==='main' && $store.state.menu.stocks.filter(s => s.i_close < s.open).map(m => m.id).includes(s.stock)).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ stocks.filter(s => s.board==='main' && $store.state.menu.stocks.filter(s => s.i_close > s.open).map(m => m.id).includes(s.stock)).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round(stocks.filter(s => s.board==='main' && $store.state.menu.stocks.filter(s => s.i_close < s.open).map(m => m.id).includes(s.stock)).length/stocks.filter(s => s.board==='main').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="board='ace'">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>ACE</span>
                          <h3 class="total-num counter">{{ stocks.filter(s => s.board==='ace').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ stocks.filter(s => s.board==='ace' && $store.state.menu.stocks.filter(s => s.i_close < s.open).map(m => m.id).includes(s.stock)).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ stocks.filter(s => s.board==='ace' && $store.state.menu.stocks.filter(s => s.i_close > s.open).map(m => m.id).includes(s.stock)).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round(stocks.filter(s => s.board==='ace' && $store.state.menu.stocks.filter(s => s.i_close < s.open).map(m => m.id).includes(s.stock)).length/stocks.filter(s => s.board==='ace').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 box-col-4 xl-50">
                  <div class="card ecommerce-widget" @click="board='leap'">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-5">
                          <span>LEAP</span>
                          <h3 class="total-num counter">{{ stocks.filter(s => s.board==='leap').length }}</h3>
                        </div>
                        <div class="col-7">
                          <div class="text-md-right">
                            <ul>
                              <li>
                                Profit
                                <b><span class="product-stts txt-success ml-2">
                                  {{ stocks.filter(s => s.board==='leap' && $store.state.menu.stocks.filter(s => s.i_close < s.open).map(m => m.id).includes(s.stock)).length }}
                                  <i class="icon-angle-up f-12 ml-1"></i>
                                </span></b>
                              </li>
                              <li>
                                Loss
                                <b><span class="product-stts txt-danger ml-2">
                                  {{ stocks.filter(s => s.board==='leap' && $store.state.menu.stocks.filter(s => s.i_close > s.open).map(m => m.id).includes(s.stock)).length }}
                                  <i class="icon-angle-down f-12 ml-1"></i>
                                </span></b>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="progress-showcase mt-4">
                        <div class="progress sm-progress-bar">
                          <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="[{width: Math.round(stocks.filter(s => s.board==='leap' && $store.state.menu.stocks.filter(s => s.i_close < s.open).map(m => m.id).includes(s.stock)).length/stocks.filter(s => s.board==='leap').length*100)+'%' }]"
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 mb-3">
                <b-button v-if="stock" id="default-lg-primary" variant="primary" class="btn-pill btn-air-primary" size="lg" @click="$router.push('/stock/ticker/'+stock.name)">View {{ stock.name }} Historical</b-button>
                <b-button v-if="stock" id="default-lg-primary" variant="primary" class="btn-pill btn-air-primary ml-3" size="lg" @click="$router.push('/stock/ticker/'+stock.name+'/date')">View {{ stock.name }} Intraday</b-button>
              </div>

              <b-row>
                <b-col xl="6">
                  <b-input-group class="datatable-btn">
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="table-responsive datatable-vue">
                <b-table
                    selectable
                    show-empty
                    stacked="md"
                    selectedVariant="success"
                    :items="stocks.filter(s => s.board === board)"
                    :fields="stockfields"
                    :filter="filter"
                    :current-page="currentPageS"
                    :per-page="perPage"
                    select-mode="single"
                    @filtered="onFiltered"
                    @row-selected="stockSelected"
                >
                </b-table>
              </div>
              <b-col md="6" class="my-1 p-0">
                <b-pagination
                    v-model="currentPageS"
                    :total-rows="totalRowsS"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>
            </div>

          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-4" v-for="(stock, i) in stocks" :key="i+'-'+stock.stock">
          <div class="card">
            <highcharts class="chartWrapper" :constructor-type="'stockChart'" :options="charts[i]"></highcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data: function () {
    return {
      year: this.$route.query.year || moment().format('YYYY'),
      month: this.$route.query.month || moment().format('MM'),
      fromdate: moment().subtract(30,'days').format('YYYY-MM-DD'),
      progress: {
        ace: [],
        leap: [],
        main: []
      },
      board: 'main',
      stockfields: [
        { key: 'stock', label: 'ID', sortable: true, },
        { key: 'name', label: 'Ticker', sortable: true, },
        { key: 'market_cap', label: 'Market Cap', sortable: true, },
        { key: 'open', label: 'Open', sortable: true, },
        { key: 'high', label: 'High', sortable: true, },
        { key: 'low', label: 'Low', sortable: true, },
        { key: 'close', label: 'Close', sortable: true, },
        { key: 'avg_price', label: 'Average', sortable: true, },
        { key: 'mid', label: 'Mid', sortable: true, },
        { key: 'pos', label: 'Pos', sortable: true, },
        { key: 'count', label: 'Count', sortable: true, },
        { key: 'hl5_pct', label: 'HL5 %', sortable: true, },
        { key: 'drop5_pct', label: 'Drop %', sortable: true, },
        { key: 'rise5_pct', label: 'Rise %', sortable: true, },
        { key: 'low5_pct', label: 'Low %', sortable: true, },
        { key: 'high5_pct', label: 'High %', sortable: true, },
        { key: 'volatile5_pct', label: 'Volatile %', sortable: true, },
        { key: 'score5', label: 'Score 5', sortable: true, },
      ],

      stocks: [],
      stock: null,
      charts: [],

      filter: null,
      totalRows: 1,
      totalRowsS: 1,
      currentPage: 1,
      currentPageS: 1,
      perPage: 25,
      pageOptions: [25, 100, 1000],
    }
  },
  computed: {
    title: function () {
      return 'High Low 5'
    },
    sortOptions() {
      return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return {text: f.label, value: f.key}
          })
    },
  },
  watch: {
    title: { immediate: true, handler() { document.title = this.title } }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchScan()
    },
    fetchScan() {
      this.$http.get(`/api/stock/scan/hl5`)
          .then(({data}) => {
            this.stocks = data.stocks
            this.charts = data.stocks.map(s => ({
              chart: {
                zoomType: 'x',
                height: 600
              },
              title: {
                text: s.stock + ' ' + s.name
              },
              subtitle: {
                text: ''
              },
              navigator: {
                enabled: false
              },
              yAxis: [{
                labels: {
                  align: 'right',
                  x: -3
                },
                title: {
                  text: 'OHLC'
                },
                height: '60%',
                lineWidth: 2,
                resize: {
                  enabled: true
                }
              }, {
                labels: {
                  align: 'right',
                  x: -3
                },
                title: {
                  text: 'Volume'
                },
                top: '65%',
                height: '35%',
                offset: 0,
                lineWidth: 2
              }],
              tooltip: {
                split: true
              },
              credits: { enabled: false },
              series: [{
                type: 'candlestick',
                name: '',
                id: '',
                data: []
              }, {
                type: 'column',
                name: 'Volume',
                data: [],
                yAxis: 1
              }]
            }))
            for (let i=0; i<this.stocks.length; i++) {
              this.fetchChart(this.stocks[i].stock, i, this.stocks[i].stock+' '+this.stocks[i].name)
            }
          })
          .catch(e => console.log(e.message))
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    stockSelected(item) {
      this.stock = item[0]
    },
    fetchChart(id, i, title) {
      let url = `/api/stock/chart/`+id+`?year=`+this.year+'&month='+this.month+'&title='+title
      if(!this.$route.query.month) {
        url = `/api/stock/chart/`+id+`?fromdate=`+this.fromdate+'&title='+title
      }
      this.$http.get(url)
          .then(({data}) => {
            this.charts[i] = data.chart
            this.charts = [ ...this.charts ]
          })
    },
    moment() {
      return moment()
    }
  }
}
</script>